export default "__VITE_ASSET__CL1t2jh1__"